import { render, staticRenderFns } from "./employee-page.vue?vue&type=template&id=66bb5519&scoped=true"
import script from "./employee-page.vue?vue&type=script&lang=js"
export * from "./employee-page.vue?vue&type=script&lang=js"
import style0 from "./employee-page.vue?vue&type=style&index=0&id=66bb5519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb5519",
  null
  
)

export default component.exports